import { graphql } from 'react-relay';

import createMutation from '../../../../relay/createMutation';

const mutation = graphql`
  mutation ApproveTutorMutation($input: ApproveTutorMutationInput!) {
    approveTutor(input: $input) {
      tutor {
        ...Tutor_tutor
      }
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/mutations/ApproveTutorMutation.js